module.exports = __webpack_public_path__ + "static/media/29ADMSPC2.2d7f3e6f.jpg";